import React, { createContext, useEffect, useState } from 'react';
import ErrorModal from '../components/Modal/ErrorModal';
import { setGlobalShowError } from '../components/utils/errorModalSingleton';

const ErrorModalContext = createContext();

export const ErrorModalProvider = ({ children }) => {
    const [message, setMessage] = useState(null);

    const showError = (msg) => setMessage(msg);
    const hideError = () => setMessage(null);

    useEffect(() => {
        setGlobalShowError(showError);
    }, []);

    return (
        <ErrorModalContext.Provider value={{ showError, hideError }}>
            {children}
            {message && <ErrorModal message={message} onClose={hideError} />}
        </ErrorModalContext.Provider>
    );
};
